import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./components/landingpage";
import AboutDescribe from "./components/aboutdescribe";
import Header from "./components/Header";
import SkillsCollection from "./components/Skills";
import Service from "./components/service";
import Portfilio from "./components/portfilio";
import Contact from "./components/contact";
import Footer from "./components/footer";
import Certificate from "./components/certificate";
import Error10 from "./components/error";
import WebScraper from "./components/webscraper";
import Blog from "./components/blog";
import BlogPost from "./components/blogpost";
import Seo from "./components/Seo";
import TechBackground from "./components/TechBackground";

const App = () => {
  return (
    <div className="flex flex-col min-h-screen bg-dark-900">
      <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
        <TechBackground />
      </div>
              <Router>
          <Header />
          <main className="relative z-10 flex-grow pt-[72px]">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route
                path="/about"
                element={
                  <>
                    <Seo
                      title="About Aashish Timsina | Backend Developer in Pokhara, Nepal"
                      description="Learn about Aashish Timsina, a backend developer and web scraper based in Pokhara, Nepal, specializing in the MERN stack and scalable API development."
                      path="/about"
                    />
                    <AboutDescribe />
                  </>
                }
              />
              <Route
                path="/contact"
                element={
                  <>
                    <Seo
                      title="Contact Aashish Timsina | Backend Developer & Web Scraper in Nepal"
                      description="Get in touch with Aashish Timsina for backend development, API, and web scraping services in Pokhara, Nepal."
                      path="/contact"
                    />
                    <Contact standalone />
                  </>
                }
              />
              <Route
                path="/service"
                element={
                  <>
                    <Seo
                      title="Backend Development Services in Nepal | Aashish Timsina"
                      description="Professional backend development, API creation, database management, and web scraping services in Pokhara, Nepal, built on the MERN stack."
                      path="/service"
                    />
                    <Service standalone />
                  </>
                }
              />
              <Route
                path="/portfolio"
                element={
                  <>
                    <Seo
                      title="Portfolio | Aashish Timsina - Backend Developer & Web Scraper"
                      description="Explore backend development and web scraping projects by Aashish Timsina, including APIs, automation, and data extraction systems."
                      path="/portfolio"
                    />
                    <Portfilio standalone />
                  </>
                }
              />
              <Route
                path="/skills"
                element={
                  <>
                    <Seo
                      title="Skills | Aashish Timsina - Backend Developer & Web Scraper"
                      description="Technical skills of Aashish Timsina: Node.js, MongoDB, Express, React, Python, and web scraping tools including Selenium, Playwright, and Cheerio."
                      path="/skills"
                    />
                    <SkillsCollection standalone />
                  </>
                }
              />
              <Route
                path="/certificate"
                element={
                  <>
                    <Seo
                      title="Certificates | Aashish Timsina - Backend Developer & Web Scraper"
                      description="Professional certifications earned by Aashish Timsina in Node.js, REST API development, SQL, and backend engineering."
                      path="/certificate"
                    />
                    <Certificate standalone />
                  </>
                }
              />
              <Route path="/webscraper" element={<WebScraper />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route
                path="*"
                element={
                  <>
                    <Seo
                      title="Page Not Found | Aashish Timsina"
                      description="The page you're looking for doesn't exist. Return to Aashish Timsina's homepage to explore backend development and web scraping services."
                      noIndex
                    />
                    <Error10 />
                  </>
                }
              />
            </Routes>
          </main>
          <div className="relative z-10">
            <Footer />
          </div>
        </Router>
    </div>
  );
};

export default App;
